import { FC } from 'react';
import { Contract } from '../../../../types/header/Contract';
import ReactivateDealFormField from './ReactivateDealFormField';
import { StyledInputWithFixedHeight, StyledSelect, StyledSpan } from './Style';

type ReactivateDealVehicleInfoProps = {
  contract: Contract;
  vehicleImg: string;
};

const ReactivateDealVehicleInfo: FC<ReactivateDealVehicleInfoProps> = ({
  contract,
  vehicleImg,
}) => {
  return (
    <div className='col-sm-6 vehicle-meta'>
      <div className='row'>
        <div className='col-sm-8 offset-sm-2'>
          <div className='vehicle-photo'>
            <img
              className='deal-vehicle'
              alt='contract.vehicleStyle'
              title='contract.vehicleStyle'
              src={vehicleImg}
            />
            <p className='text-center'>
              <b>{contract.vehicleStyle}</b>
            </p>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-6 col-sm-6'>
          <div className='row vertical'>
            <div className='col-5 text-end'>
              <label>Vehicle Type</label>
            </div>
            <div className='col-7'>
              <div className='value-block'>
                <div>
                  <StyledSelect
                    id='vehicleType'
                    name='vehicleType'
                    className='form-control'
                    disabled
                    value={contract.vehicleType?.name}
                  >
                    <option>{contract.vehicleType?.name}</option>
                  </StyledSelect>
                </div>
              </div>
            </div>
          </div>
          <div className='row vertical'>
            <div className='col-5 text-end'>
              <label>Color</label>
            </div>
            <div className='col-7'>
              <div className='value-block'>
                <div>
                  <StyledInputWithFixedHeight
                    type='text'
                    id='color'
                    name='color'
                    className='form-control'
                    placeholder='N/A'
                    disabled
                    readOnly
                    value={contract.vehicleExtColor}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-6 col-sm-6'>
          <div className='row vertical'>
            <div className='col-4 text-end'>
              <label>Delivery Miles</label>
            </div>
            <div className='col-8'>
              <div className='value-block'>
                <div>
                  <StyledInputWithFixedHeight
                    type='text'
                    id='deliveryMiles'
                    name='deliveryMiles'
                    className='form-control'
                    placeholder='N/A'
                    readOnly
                    disabled
                    value={contract.deliveryMileage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row vertical'>
            <div className='col-4 text-end'>
              <label>MSRP</label>
            </div>
            <div className='col-8'>
              <div className='value-block'>
                <div className='input-group'>
                  <StyledSpan
                    hasWrapperClass={false}
                    applyPadding={true}
                    className='input-group-addon'
                  >
                    $
                  </StyledSpan>
                  <StyledInputWithFixedHeight
                    type='text'
                    id='msrp'
                    name='msrp'
                    className='form-control'
                    placeholder='N/A'
                    readOnly
                    required
                    value={contract.msrp}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-6 col-sm-6'>
          <div className='row vertical static'>
            <div className='col-3 text-end'>
              <label>VIN</label>
            </div>
            <div className='col-9'>
              <div className='value-block static'>
                <span>{contract?.vin}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='col-6 col-sm-6 nice-checkboxes'>
          <label className='flush-left'>
            <input type='checkbox' name='hasExtendedWarranty' disabled />
            <em>Has extended warranty (Expiration unknown)</em>
          </label>
        </div>
      </div>
      <div className='row end-section'>
        <div className='col-6 col-sm-6'>
          <ReactivateDealFormField
            inputValue={contract?.warrantyMiles}
            labelValue='Warranty Exp. Miles'
            fieldName={!contract?.hasExtendedWarranty ? 'warrantyExpiryMiles' : null}
            isReadOnly={true}
            isInputWrapper={true}
            isDisabled={true}
            hasWrapperClass={false}
          />
        </div>
        <div className='col-6 col-sm-6'>
          <ReactivateDealFormField
            inputValue={contract?.warrantyDate}
            labelValue='Warranty Exp. Date'
            fieldName={!contract?.hasExtendedWarranty ? 'warrantyExpiryDate' : null}
            isReadOnly={true}
            isDateField={true}
            isDisabled={true}
            isCalendarDisabled={true}
            hasWrapperClass={true}
            applyPadding={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ReactivateDealVehicleInfo;
